import { STATUS_ICON_CHECK_O, STATUS_ICON_LOADING, STATUS_ICON_TIMES_O } from '@/common/utils/statuses';
import { ComputeImage_DiskFormat, ComputeImage_Status } from '@schema';
import i18n from '@/common/i18n';
import computedLocale from '@/common/utils/computedLocale';

export enum IMAGE_TYPE {
  ISO = 'iso',
  TEMPLATE = 'template'
}

export const IMAGE_STATUS_GROUPS = {
  [ComputeImage_Status.ACTIVE]: [ComputeImage_Status.ACTIVE],
  [ComputeImage_Status.UPLOADING]: [ComputeImage_Status.QUEUED, ComputeImage_Status.UPLOADING],
  [ComputeImage_Status.SAVING]: [ComputeImage_Status.SAVING],
  importing: 'importing',
  unavailable: [ComputeImage_Status.KILLED, ComputeImage_Status.DELETED, ComputeImage_Status.PENDING_DELETE],
  [ComputeImage_Status.DEACTIVATED]: [ComputeImage_Status.DEACTIVATED],
};

export const IMAGE_STATUS_GROUPS_TEXT_KEYS = {
  [ComputeImage_Status.ACTIVE]: ComputeImage_Status.ACTIVE,
  [ComputeImage_Status.UPLOADING]: ComputeImage_Status.QUEUED,
  [ComputeImage_Status.SAVING]: ComputeImage_Status.SAVING,
  importing: 'importing',
  unavailable: ComputeImage_Status.DELETED,
  [ComputeImage_Status.DEACTIVATED]: ComputeImage_Status.DEACTIVATED,
};

type ComputeImageStatus = Record<ComputeImage_Status | 'importing', StatusData>

export const IMAGE_STATUS_MAP = computedLocale<ComputeImageStatus>(() => ({
  [ComputeImage_Status.ACTIVE]: {
    icon: STATUS_ICON_CHECK_O,
    text: i18n.t('Compute~Image~Status~Active'),
  },
  [ComputeImage_Status.DEACTIVATED]: {
    icon: STATUS_ICON_TIMES_O,
    text: i18n.t('Deactivated')
  },
  [ComputeImage_Status.DELETED]: {
    icon: STATUS_ICON_TIMES_O,
    text: i18n.t('Unavailable')
  },
  importing: {
    icon: STATUS_ICON_LOADING,
    text: i18n.t('Importing')
  },
  [ComputeImage_Status.KILLED]: {
    icon: STATUS_ICON_TIMES_O,
    text: i18n.t('Unavailable')
  },
  [ComputeImage_Status.PENDING_DELETE]: {
    icon: STATUS_ICON_TIMES_O,
    text: i18n.t('Unavailable')
  },
  [ComputeImage_Status.QUEUED]: {
    icon: STATUS_ICON_LOADING,
    text: i18n.t('Uploading')
  },
  [ComputeImage_Status.SAVING]: {
    icon: STATUS_ICON_LOADING,
    text: i18n.t('Saving')
  },
  [ComputeImage_Status.UPLOADING]: {
    icon: STATUS_ICON_LOADING,
    text: i18n.t('Uploading')
  },
}));

export const IMAGE_TYPES = {
  [IMAGE_TYPE.ISO]: [ComputeImage_DiskFormat.ISO],
  [IMAGE_TYPE.TEMPLATE]: [
    ComputeImage_DiskFormat.AKI,
    ComputeImage_DiskFormat.AMI,
    ComputeImage_DiskFormat.ARI,
    ComputeImage_DiskFormat.PLOOP,
    ComputeImage_DiskFormat.QCOW2,
    ComputeImage_DiskFormat.RAW,
    ComputeImage_DiskFormat.VDI,
    ComputeImage_DiskFormat.VHD,
    ComputeImage_DiskFormat.VHDX,
    ComputeImage_DiskFormat.VMDK,
  ]
};
